import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { colors } from '../../constants'

export const ExpanderDom = styled.div`
    width: 100%;

    ${({ noMargin }) => !noMargin && `margin-right: 0px;`}
    ${({ inTable }) => inTable && `margin-left: 0px;`}

`

export const Body = styled.div`
    ${({ noAnimation }) => !noAnimation && 'transition: all 0.5s;'}
    transform-origin: top;
    opacity: 0;
    transform: scaleY(0);
    max-height: 0px;

    ${({ isOpen, maxHeightBody }) =>
        isOpen &&
        `
    max-height: ${maxHeightBody}px;
    opacity: 1;
    transform: scaleY(1);
    overflow: auto;
  `}
`

export const IconWrapper = styled.div`
    display: inline-block;
    transition: all 0.3s;

    ${({ marginRight }) => marginRight && `margin-right: ${marginRight};`}

    ${({ marginLeft }) => marginLeft && `margin-left: ${marginLeft};`}

  ${({ size }) => (size ? `font-size: ${size};` : 'font-size: 13px;')}

  ${({ loading }) => loading && `animation: rotate 1.5s linear infinite;`}

  @keyframes rotate {
        to {
            transform: rotate(360deg);
        }
    }

    ${({ isOpen, rotateAnimation }) => {
        if (isOpen && rotateAnimation) return 'transform: rotate(90deg);'
        if (isOpen && !rotateAnimation) return 'transform: rotate(360deg);'
    }}
`

export const Icon = styled(FontAwesomeIcon)``

export const Header = styled.div`
    ${({ bold }) => bold && `font-weight: bold;`}
    font-size: 14px;
    vertical-align: center;
    ${({ disabled, color }) => (!disabled ? `cursor: pointer;` : `cursor: context-menu; color: ${colors.greylighter};`)}
`
